// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sortable-container {
    margin: auto;
    padding: 0px;
    font: var(--font);
}

.sortable-component.vertical {
    display: flex;
    flex-wrap:wrap;
    justify-content: flex-start;
    align-items: stretch;
}

.sortable-component.vertical .sortable-container {
    min-width: 175px;
    margin: 0px;
    padding: 10px;
    flex-grow: 1;
}

.sortable-container-header {
    margin: 0px;
    background-color: var(--background-color);
}

.sortable-container-body {
    margin: 0px;
    padding: 3px;
    width: 100%;
    min-height: 48px;
    border-radius: 3px;
    background-color: var(--secondary-background-color);
}

.sortable-item, .sortable-item:hover {
    margin: 5px;
    background-color: var(--primary-color);
    color: white;
    padding-top: 3px;
    padding-bottom: 3px;
    height: 100%;
    cursor: grab;
    -webkit-user-select: none;
            user-select: none;
}

.sortable-item:active {
    cursor: grabbing;
}

.active {
    opacity: 0.5;
}

.sortable-item.dragging {
    transform-origin: 0 0;
}

.sortable-component.vertical .sortable-item {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/SortableComponent.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mDAAmD;AACvD;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".sortable-container {\n    margin: auto;\n    padding: 0px;\n    font: var(--font);\n}\n\n.sortable-component.vertical {\n    display: flex;\n    flex-wrap:wrap;\n    justify-content: flex-start;\n    align-items: stretch;\n}\n\n.sortable-component.vertical .sortable-container {\n    min-width: 175px;\n    margin: 0px;\n    padding: 10px;\n    flex-grow: 1;\n}\n\n.sortable-container-header {\n    margin: 0px;\n    background-color: var(--background-color);\n}\n\n.sortable-container-body {\n    margin: 0px;\n    padding: 3px;\n    width: 100%;\n    min-height: 48px;\n    border-radius: 3px;\n    background-color: var(--secondary-background-color);\n}\n\n.sortable-item, .sortable-item:hover {\n    margin: 5px;\n    background-color: var(--primary-color);\n    color: white;\n    padding-top: 3px;\n    padding-bottom: 3px;\n    height: 100%;\n    cursor: grab;\n    user-select: none;\n}\n\n.sortable-item:active {\n    cursor: grabbing;\n}\n\n.active {\n    opacity: 0.5;\n}\n\n.sortable-item.dragging {\n    transform-origin: 0 0;\n}\n\n.sortable-component.vertical .sortable-item {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
